// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FxLYN","colBig":"styles_colBig__1RMdT","colSmall":"styles_colSmall__ohi7Y","shopifyNameWrapper":"styles_shopifyNameWrapper__1_D4n"};